<template>
  <div>
    <div class="page-404">
      <div class="img"></div>
      <p>你所找的页面不在这！</p>
      <a class="btn" href="/">回到首页</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "404",
    data() {
      return {};
    },

    mounted() {},

    methods: {},
  };
</script>


<style lang="scss" scoped>
.page-404 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  padding-bottom: 20vh;

  .img {
    // background: url(//static.theone.art/pc/images/404.png) no-repeat 50%;
    background: url(../../assets/images/common/404.png) no-repeat 50%;
    background-size: 100% auto;
    width: 80%;
    height: 30vh;
  }
  p {
    font-size: 16px;
    color: #767676;
    margin-bottom: 24px;
  }
  .btn {
    width: 155px;
    height: 45px;
    background: #b3b3b3;
    border-radius: 23px;
    font-size: 20px;
    color: #767676;
    line-height: 45px;
    text-align: center;
  }
}
</style>

